export const sanitizeHtml = (target: string | undefined) => {
  const regex = /(<([^>]+)>)/gi
  return target ? target.replace(regex, '') : null
}
